"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useThumbnail = void 0;

var react_1 = require("react");

var emitter_context_1 = require("./emitter-context");

var useThumbnail = function useThumbnail() {
  var emitter = (0, react_1.useContext)(emitter_context_1.ThumbnailEmitterContext);

  if (!emitter) {
    throw new TypeError('Expected Player event emitter context');
  }

  var returnValue = (0, react_1.useMemo)(function () {
    return {
      emitter: emitter
    };
  }, [emitter]);
  return returnValue;
};

exports.useThumbnail = useThumbnail;